import { MaterialCommodity, Weld } from '@bechtel/types';

export type Commodity = MaterialCommodity | Weld;
